export const highlightSearchString = (
  text: string,
  searchString: string,
  color?: string,
) => {
  if (!searchString || !text) return text;
 
  const escapedSearch = searchString.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
 
  const regex = new RegExp(escapedSearch, "gi");
 
  return text.replace(
    regex,
    (match) =>
      `<span style="background-color: ${color ?? "yellow"}">${match}</span>`,
  );
};
